import { useEffect, useState } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import { loginUrl } from '../../utils/loginRedirect';

export default function AbonnementRetour() {
    const { scope } = useParams();
    const { user } = useAuthStore();
    const [status, setStatus] = useState('loading');

    const sessionId = new URLSearchParams(window.location.search).get('session_id');
    const scopePath = `/compte/quiz/${scope}`;

    useEffect(() => {
        if (!sessionId) {
            setStatus('error');
            return;
        }
        // Le webhook Stripe active l'abonnement côté serveur.
        // On attend juste un court instant pour laisser le webhook se traiter.
        const timer = setTimeout(() => setStatus('success'), 2000);
        return () => clearTimeout(timer);
    }, [sessionId]);

    if (!user) return <Navigate to={loginUrl()} replace />;

    return (
        <div className="abonnement-page" style={{ textAlign: 'center', paddingTop: '60px' }}>
            {status === 'loading' && (
                <div>
                    <div className="spinner" style={{ margin: '0 auto 16px' }} />
                    <p>Finalisation de votre paiement...</p>
                </div>
            )}

            {status === 'success' && (
                <div>
                    <h1 style={{ color: 'var(--success)', marginBottom: '16px' }}>Paiement confirmé !</h1>
                    <p style={{ marginBottom: '24px' }}>
                        Votre abonnement est maintenant actif. Vous avez accès à tous les QCM de cette thématique.
                    </p>
                    <Link to={scopePath} className="btn btn-primary">
                        Commencer mes révisions
                    </Link>
                </div>
            )}

            {status === 'error' && (
                <div>
                    <h1 style={{ color: 'var(--error)', marginBottom: '16px' }}>Erreur</h1>
                    <p>Session de paiement introuvable.</p>
                    <Link to={scopePath} className="btn btn-primary">Retour</Link>
                </div>
            )}
        </div>
    );
}
